import { apiService } from './apiService'

const parseResponse = async (response) => {
  const payload = await response.json().catch(() => ({}))
  if (!response.ok) {
    const error = new Error(payload.message || `HTTP error! status: ${response.status}`)
    error.status = response.status
    error.details = payload
    throw error
  }
  return payload
}

export const socialStudioService = {
  async getToday(date) {
    const params = new URLSearchParams({ date })
    return parseResponse(await apiService.request(`/api/social-studio/today?${params}`, { method: 'GET' }))
  },

  async getHistory({ page = 1, limit = 20 } = {}) {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) })
    return parseResponse(await apiService.request(`/api/social-studio/history?${params}`, { method: 'GET' }))
  },

  async savePost(postId, payload) {
    return parseResponse(await apiService.request(`/api/social-studio/posts/${encodeURIComponent(postId)}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    }))
  },

  async updateStatus(postId, status, revision) {
    return parseResponse(await apiService.request(`/api/social-studio/posts/${encodeURIComponent(postId)}/status`, {
      method: 'POST',
      body: JSON.stringify({ status, revision }),
    }))
  },

  async replacePost(postId) {
    return parseResponse(await apiService.request(`/api/social-studio/posts/${encodeURIComponent(postId)}/replace`, {
      method: 'POST',
      body: '{}',
    }))
  },

  async saveSettings(payload) {
    return parseResponse(await apiService.request('/api/social-studio/settings', {
      method: 'PUT',
      body: JSON.stringify(payload),
    }))
  },
}
